import { render, staticRenderFns } from "./DeliveryBranchLink.vue?vue&type=template&id=37762e48"
import script from "./DeliveryBranchLink.vue?vue&type=script&lang=js"
export * from "./DeliveryBranchLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports